import { render } from "./component-egrul-subtitle.vue?vue&type=template&id=8fd5f35c"
import script from "./component-egrul-subtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-subtitle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fd5f35c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fd5f35c', __exports__)) {
    api.reload('8fd5f35c', __exports__)
  }
  
  module.hot.accept("./component-egrul-subtitle.vue?vue&type=template&id=8fd5f35c", () => {
    api.rerender('8fd5f35c', render)
  })

}


export default __exports__